module.exports = __webpack_public_path__ + "static/media/om_eyeshape_downturned_amber.bb58c9d7.png";